export const BACK_OFFICE_ROLE = 'back_office_role';
export const SUPER_USER_ROLE = 'super_user_role';
